import { AbstractControl, ValidatorFn } from '@angular/forms';

export class NonNegativeIntegersValidator {
  static validate(): ValidatorFn {
    return (control: AbstractControl): Record<string, unknown> | null => {
      if (!control.value && control.value !== 0) {
        return { nonInteger: true };
      }

      const match = String(control.value)?.match(/^[+-]?[0-9]*$/);
      if (!match) {
        return { nonInteger: true };
      }

      return Number(match) < 0 ? { negative: true } : null;
    };
  }
}
